var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "item-row-quote-builder-parts quote-builder-item-row type-part",
      class: [
        {
          "is-selected": _vm.isSelected,
          "is-open": _vm.isSelected && !_vm.isFullWidth,
        },
        `quote-builder-item-${_vm.$theme.name}`,
        _vm.defaultRowColourClass(
          _vm.item,
          _vm.getItemAssessments(_vm.item),
          false
        ),
        _vm.rowDisplayStatus(_vm.item, _vm.getItemAssessments(_vm.item)),
      ],
      attrs: { id: _vm.item.quoteItemId },
    },
    [
      _c(
        "div",
        { on: { click: (event) => _vm.handleClick(event) } },
        [
          _c("quote-builder-part-item-template", {
            attrs: {
              "is-full-width": _vm.isFullWidth,
              "is-header": false,
              "is-fully-expanded": _vm.isSelected && !_vm.isFullWidth,
            },
            on: { handleClick: _vm.handleClick },
            scopedSlots: _vm._u(
              [
                {
                  key: "description",
                  fn: function () {
                    return [
                      _vm.isSelected &&
                      !_vm.item.deleteOtherItem &&
                      !_vm.readOnlyView &&
                      !_vm.audanetLock &&
                      _vm.$company.setting.itemAutoCompleteEnabled &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("item-description-autocomplete", {
                            directives: [
                              {
                                name: "focus-next",
                                rawName: "v-focus-next:callback",
                                value: _vm.handleTransitionNextRow,
                                expression: "handleTransitionNextRow",
                                arg: "callback",
                              },
                              {
                                name: "focus-next-element-on-arrow-directive",
                                rawName:
                                  "v-focus-next-element-on-arrow-directive:callback",
                                value: _vm.handleArrowKeys,
                                expression: "handleArrowKeys",
                                arg: "callback",
                              },
                            ],
                            attrs: {
                              placeholder: "Item Description",
                              id: _vm.item.quoteItemId + "-itemDesc",
                              "schedule-id": _vm.vehicle.scheduleId,
                              "body-id": _vm.vehicle.bodyId,
                              "class-prop":
                                (!_vm.isValidItemDesc(_vm.item.quoteItemId)
                                  ? "is-danger "
                                  : "") +
                                _vm.defaultRowColourClass(
                                  _vm.item,
                                  _vm.getItemAssessments(_vm.item)
                                ),
                              "item-type": _vm.ItemTypes.PARTS,
                              "times-style": _vm.labourType,
                            },
                            model: {
                              value: _vm.item.itemDesc,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "itemDesc", $$v)
                              },
                              expression: "item.itemDesc",
                            },
                          })
                        : _vm.isSelected &&
                          !_vm.item.deleteOtherItem &&
                          !_vm.readOnlyView &&
                          !_vm.audanetLock &&
                          !_vm.$company.setting.itemAutoCompleteEnabled &&
                          !_vm.isItemRemoved(
                            _vm.item,
                            _vm.getItemAssessments(_vm.item)
                          )
                        ? _c("input", {
                            directives: [
                              {
                                name: "focus-next",
                                rawName: "v-focus-next:callback",
                                value: _vm.handleTransitionNextRow,
                                expression: "handleTransitionNextRow",
                                arg: "callback",
                              },
                              {
                                name: "focus-next-element-on-arrow-directive",
                                rawName:
                                  "v-focus-next-element-on-arrow-directive:callback",
                                value: _vm.handleArrowKeys,
                                expression: "handleArrowKeys",
                                arg: "callback",
                              },
                              {
                                name: "focus-inserted",
                                rawName: "v-focus-inserted",
                                value: { focus: _vm.$userInfo.scrollItemPart },
                                expression:
                                  "{ focus: $userInfo.scrollItemPart }",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.item.itemDesc,
                                expression: "item.itemDesc",
                              },
                            ],
                            staticClass: "input",
                            class: [
                              _vm.defaultRowColourClass(
                                _vm.item,
                                _vm.getItemAssessments(_vm.item)
                              ),
                              !_vm.isValidItemDesc(_vm.item.quoteItemId)
                                ? "is-danger"
                                : "",
                            ],
                            attrs: {
                              id: _vm.item.quoteItemId + "-itemDesc",
                              placeholder: "Item Description",
                              disabled: _vm.item.deleteOtherItem,
                            },
                            domProps: { value: _vm.item.itemDesc },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.item,
                                  "itemDesc",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _c(
                            "span",
                            {
                              staticClass: "is-quote-item-field-editable pl-2",
                              class: {
                                "has-text-danger": !_vm.isValidItemDesc(
                                  _vm.item.quoteItemId
                                ),
                              },
                              attrs: { id: _vm.item.quoteItemId + "-itemDesc" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.item.itemDesc || "Item Description"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                      _vm.isSelected
                        ? _c("input", {
                            directives: [
                              {
                                name: "focus-next",
                                rawName: "v-focus-next:callback",
                                value: _vm.handleTransitionNextRow,
                                expression: "handleTransitionNextRow",
                                arg: "callback",
                              },
                              {
                                name: "focus-next-element-on-arrow-directive",
                                rawName:
                                  "v-focus-next-element-on-arrow-directive:callback",
                                value: _vm.handleArrowKeys,
                                expression: "handleArrowKeys",
                                arg: "callback",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.item.partNo,
                                expression: "item.partNo",
                              },
                            ],
                            staticClass: "input is-uppercase",
                            class: _vm.defaultRowColourClass(_vm.item),
                            attrs: {
                              id: _vm.item.quoteItemId + "-itemNo",
                              placeholder: "Part No.",
                              maxlength: "24",
                              disabled:
                                _vm.item.deleteOtherItem ||
                                _vm.readOnlyComputed,
                            },
                            domProps: { value: _vm.item.partNo },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.item,
                                  "partNo",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _c(
                            "span",
                            {
                              staticClass:
                                "is-italic is-quote-item-field-editable pl-2",
                              class: !_vm.item.partNo
                                ? "has-text-grey-light"
                                : "",
                              attrs: { id: _vm.item.quoteItemId + "-itemNo" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.item.partNo || "Part No.") +
                                  " "
                              ),
                            ]
                          ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "report",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "is-clickable mt-1",
                          class: {
                            disabled:
                              _vm.item.deleteOtherItem ||
                              !_vm.canMakeReportOnly(_vm.item),
                          },
                          on: {
                            click: ($event) =>
                              _vm.updateReport(_vm.item, $event),
                          },
                        },
                        [
                          _c("div", { staticClass: "is-flex" }, [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      theme: "secondary",
                                      enabled: true,
                                    },
                                    expression:
                                      "{ theme: 'secondary', enabled: true }",
                                  },
                                ],
                                staticClass: "tag p-1 px-2",
                                class: _vm.item.reportOnly
                                  ? "is-dark is-danger"
                                  : "is-white",
                                attrs: { content: "Report" },
                              },
                              [_vm._v("R ")]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "part_type",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "is-flex is-justify-content-center" },
                        [
                          _vm.isSelected &&
                          !_vm.item.deleteOtherItem &&
                          !_vm.readOnlyView &&
                          !_vm.isItemRemoved(
                            _vm.item,
                            _vm.getItemAssessments(_vm.item)
                          )
                            ? _c("div", { staticClass: "select" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.item.mark,
                                        expression: "item.mark",
                                      },
                                      {
                                        name: "focus-next",
                                        rawName: "v-focus-next:callback",
                                        value: _vm.handleTransitionNextRow,
                                        expression: "handleTransitionNextRow",
                                        arg: "callback",
                                      },
                                    ],
                                    class: _vm.defaultRowColourClass(
                                      _vm.item,
                                      _vm.getItemAssessments(_vm.item)
                                    ),
                                    attrs: {
                                      disabled: _vm.item.deleteOtherItem,
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.item,
                                            "mark",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                        function ($event) {
                                          return _vm.onPartConditionChange(
                                            _vm.item
                                          )
                                        },
                                      ],
                                    },
                                  },
                                  _vm._l(
                                    _vm.partTypes,
                                    function (typeObject, type) {
                                      return _c(
                                        "option",
                                        {
                                          key: typeObject.value,
                                          attrs: {
                                            title: typeObject.description,
                                          },
                                          domProps: { value: typeObject.value },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$filters.formatPartCondition(
                                                type
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : _c("span", { staticClass: "mt-1" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatPartType(_vm.item.mark)
                                  )
                                ),
                              ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "part_qty",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          class: [
                            _vm.defaultCellColourClass(
                              _vm.item,
                              "itemQuantity"
                            ),
                          ],
                        },
                        [
                          _vm.isSelected &&
                          !_vm.readOnlyView &&
                          !_vm.isItemRemoved(
                            _vm.item,
                            _vm.getItemAssessments(_vm.item)
                          )
                            ? _c("vue-numeric", {
                                directives: [
                                  {
                                    name: "focus-next",
                                    rawName: "v-focus-next:callback",
                                    value: _vm.handleTransitionNextRow,
                                    expression: "handleTransitionNextRow",
                                    arg: "callback",
                                  },
                                  {
                                    name: "focus-next-element-on-arrow-directive",
                                    rawName:
                                      "v-focus-next-element-on-arrow-directive:callback",
                                    value: _vm.handleArrowKeys,
                                    expression: "handleArrowKeys",
                                    arg: "callback",
                                  },
                                ],
                                staticClass: "input has-text-right",
                                class: _vm.defaultRowColourClass(
                                  _vm.item,
                                  _vm.getItemAssessments(_vm.item)
                                ),
                                attrs: {
                                  id: _vm.item.quoteItemId + "-qty",
                                  minus: _vm.subQuoteNo !== 0,
                                  precision: 0,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateValue(_vm.index, _vm.item)
                                  },
                                },
                                model: {
                                  value: _vm.item.itemQuantity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.item,
                                      "itemQuantity",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "item.itemQuantity",
                                },
                              })
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "is-quote-item-field-editable end mt-1",
                                  attrs: { id: _vm.item.quoteItemId + "-qty" },
                                },
                                [_vm._v(_vm._s(_vm.item.itemQuantity))]
                              ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "part_buy",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "cell is-col-span-3" },
                        [
                          _vm.isSelected &&
                          !_vm.item.deleteOtherItem &&
                          !_vm.readOnlyView &&
                          !_vm.isItemRemoved(
                            _vm.item,
                            _vm.getItemAssessments(_vm.item)
                          )
                            ? _c("vue-numeric", {
                                directives: [
                                  {
                                    name: "focus-next",
                                    rawName: "v-focus-next:callback",
                                    value: _vm.handleTransitionNextRow,
                                    expression: "handleTransitionNextRow",
                                    arg: "callback",
                                  },
                                  {
                                    name: "focus-next-element-on-arrow-directive",
                                    rawName:
                                      "v-focus-next-element-on-arrow-directive:callback",
                                    value: _vm.handleArrowKeys,
                                    expression: "handleArrowKeys",
                                    arg: "callback",
                                  },
                                ],
                                staticClass: "input has-text-right",
                                class: _vm.defaultRowColourClass(
                                  _vm.item,
                                  _vm.getItemAssessments(_vm.item)
                                ),
                                attrs: {
                                  min: 0,
                                  id: _vm.item.quoteItemId + "-buy",
                                  disabled:
                                    _vm.item.deleteOtherItem ||
                                    (_vm.item.quantityReceived > 0 &&
                                      !_vm.$userInfo.isSupportUser),
                                  precision: 2,
                                },
                                nativeOn: {
                                  input: function ($event) {
                                    return _vm.handleOnPriceChange(_vm.item)
                                  },
                                },
                                model: {
                                  value: _vm.item.buyPrice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "buyPrice", _vm._n($$v))
                                  },
                                  expression: "item.buyPrice",
                                },
                              })
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "is-quote-item-field-editable end",
                                  attrs: { id: _vm.item.quoteItemId + "-buy" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        _vm.item.buyPrice,
                                        _vm.$userInfo.locale,
                                        2
                                      )
                                    )
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "part_markup",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "cell is-col-span-3" },
                        [
                          _vm.isSelected &&
                          !_vm.item.deleteOtherItem &&
                          !_vm.readOnlyView &&
                          !_vm.isItemRemoved(
                            _vm.item,
                            _vm.getItemAssessments(_vm.item)
                          )
                            ? _c("vue-numeric", {
                                directives: [
                                  {
                                    name: "focus-next",
                                    rawName: "v-focus-next:callback",
                                    value: _vm.handleTransitionNextRow,
                                    expression: "handleTransitionNextRow",
                                    arg: "callback",
                                  },
                                  {
                                    name: "focus-next-element-on-arrow-directive",
                                    rawName:
                                      "v-focus-next-element-on-arrow-directive:callback",
                                    value: _vm.handleArrowKeys,
                                    expression: "handleArrowKeys",
                                    arg: "callback",
                                  },
                                ],
                                staticClass: "input has-text-right",
                                class: _vm.defaultRowColourClass(
                                  _vm.item,
                                  _vm.getItemAssessments(_vm.item)
                                ),
                                attrs: {
                                  id: _vm.item.quoteItemId + "-markup",
                                  minus: true,
                                  precision: 2,
                                  disabled: _vm.item.deleteOtherItem,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateTotal()
                                  },
                                },
                                nativeOn: {
                                  input: function ($event) {
                                    return _vm.handleOnPriceChange(_vm.item)
                                  },
                                },
                                model: {
                                  value: _vm.item.markupValue,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.item,
                                      "markupValue",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "item.markupValue",
                                },
                              })
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "is-quote-item-field-editable end mt-1",
                                  attrs: {
                                    id: _vm.item.quoteItemId + "-markup",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        _vm.item.markupValue,
                                        _vm.$userInfo.locale,
                                        2
                                      )
                                    )
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "part_sell",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "cell is-col-span-3" },
                        [
                          _vm.isSelected &&
                          !_vm.readOnlyView &&
                          !_vm.isItemRemoved(
                            _vm.item,
                            _vm.getItemAssessments(_vm.item)
                          )
                            ? _c("vue-numeric", {
                                directives: [
                                  {
                                    name: "focus-next",
                                    rawName: "v-focus-next:callback",
                                    value: _vm.handleTransitionNextRow,
                                    expression: "handleTransitionNextRow",
                                    arg: "callback",
                                  },
                                  {
                                    name: "focus-next-element-on-arrow-directive",
                                    rawName:
                                      "v-focus-next-element-on-arrow-directive:callback",
                                    value: _vm.handleArrowKeys,
                                    expression: "handleArrowKeys",
                                    arg: "callback",
                                  },
                                ],
                                staticClass: "input has-text-right",
                                class: _vm.defaultRowColourClass(
                                  _vm.item,
                                  _vm.getItemAssessments(_vm.item)
                                ),
                                attrs: {
                                  minus: true,
                                  id: _vm.item.quoteItemId + "-unit",
                                  precision: 2,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateMarkup(_vm.index, _vm.item)
                                  },
                                },
                                nativeOn: {
                                  input: function ($event) {
                                    return _vm.handleOnPriceChange(_vm.item)
                                  },
                                },
                                model: {
                                  value: _vm.item.value,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "value", _vm._n($$v))
                                  },
                                  expression: "item.value",
                                },
                              })
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "is-quote-item-field-editable end",
                                  attrs: { id: _vm.item.quoteItemId + "-unit" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$filters.formatCurrency(
                                          _vm.item.value,
                                          _vm.$userInfo.locale,
                                          2
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "total_value",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "is-flex is-justify-content-end",
                          class: {
                            "has-text-danger":
                              _vm.item.markupValue * _vm.item.itemQuantity ==
                                0 ||
                              !(_vm.item.markupValue * _vm.item.itemQuantity),
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "is-quote-item-field-editable mt-1",
                              attrs: {
                                id: _vm.item.quoteItemId + "-total-val",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.item.markupValue *
                                        _vm.item.itemQuantity,
                                      _vm.$userInfo.locale,
                                      false,
                                      2
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                _vm.item.itemComment
                  ? {
                      key: "comment",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    theme: "secondary",
                                    enabled: true,
                                    content: _vm.item.itemComment,
                                  },
                                  expression:
                                    "{ theme: 'secondary', enabled: true, content:item.itemComment }",
                                },
                              ],
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "mdi has-text-primary is-primary mdi-18px mdi-message-reply-text mr-1 is-clickable",
                              }),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                {
                  key: "assessment_status",
                  fn: function () {
                    return [
                      _vm.showAssessment
                        ? _c("supplementary-icon", {
                            staticClass: "icon",
                            attrs: {
                              item: _vm.item,
                              "item-assessments": _vm.getItemAssessments(
                                _vm.item
                              ),
                              "next-assessment-number": _vm.nextSupplemetryNo,
                              "quoting-method": _vm.quotingMethod,
                              "icon-size": 4,
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "part_status",
                  fn: function () {
                    return [
                      _c(
                        "button",
                        {
                          staticClass:
                            "button is-ghost is-small tooltip px-0 mx-1",
                          attrs: {
                            "data-tooltip": _vm.getPartStatus(_vm.item)?.title,
                          },
                          on: {
                            click: (e) =>
                              _vm.$emit(
                                "goToPartsCheck",
                                e,
                                _vm.item.partsCheckReferenceNo,
                                "quote",
                                _vm.item
                              ),
                          },
                        },
                        [
                          _c("span", {
                            class: [_vm.getPartStatus(_vm.item)?.classStatus],
                          }),
                          _c("label"),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "delete_button",
                  fn: function () {
                    return [
                      _c(
                        "button",
                        {
                          staticClass:
                            "button is-ghost is-small tooltip px-0 has-text-grey-lighter",
                          attrs: {
                            "data-tooltip": "Delete",
                            disabled: _vm.readOnlyComputed,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("deleteItem", _vm.item)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "material-symbols-rounded",
                              class: { "is-clickable": !_vm.readOnlyComputed },
                              on: {
                                mouseenter: function ($event) {
                                  return $event.target.classList.add(
                                    "has-text-danger"
                                  )
                                },
                                mouseleave: function ($event) {
                                  return $event.target.classList.remove(
                                    "has-text-danger"
                                  )
                                },
                              },
                            },
                            [_vm._v(" delete ")]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "drag_button",
                  fn: function () {
                    return [
                      _c(
                        "button",
                        {
                          staticClass:
                            "button is-ghost is-small tooltip item-drag-handle has-text-grey-light px-0",
                          attrs: {
                            "data-tooltip": "Drag",
                            disabled: _vm.readOnlyComputed,
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "mdi mdi-drag-vertical mdi-24px",
                            class: { "is-clickable": !_vm.readOnlyComputed },
                          }),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "lineNo",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                theme: "secondary",
                                enabled: true,
                                content: "Line Number",
                              },
                              expression:
                                "{ theme: 'secondary', enabled: true, content: 'Line Number' }",
                            },
                          ],
                        },
                        [
                          _vm.$userInfo.isSupportUser &&
                          !_vm.readOnlyView &&
                          !_vm.isItemRemoved(
                            _vm.item,
                            _vm.getItemAssessments(_vm.item)
                          )
                            ? _c("vue-numeric", {
                                directives: [
                                  {
                                    name: "focus-next",
                                    rawName: "v-focus-next:callback",
                                    value: _vm.handleTransitionNextRow,
                                    expression: "handleTransitionNextRow",
                                    arg: "callback",
                                  },
                                ],
                                staticClass: "input has-text-right",
                                class: _vm.defaultRowColourClass(
                                  _vm.item,
                                  _vm.getItemAssessments(_vm.item)
                                ),
                                attrs: { precision: 0, separator: "" },
                                model: {
                                  value: _vm.item.lineNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.item,
                                      "lineNumber",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "item.lineNumber",
                                },
                              })
                            : _c("span", [_vm._v(_vm._s(_vm.item.lineNumber))]),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "itemNo",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                theme: "secondary",
                                enabled: true,
                                content: "Item Number",
                              },
                              expression:
                                "{ theme: 'secondary', enabled: true, content: 'Item Number' }",
                            },
                          ],
                        },
                        [
                          !_vm.item.deleteOtherItem &&
                          !_vm.readOnlyView &&
                          !_vm.audanetLock &&
                          !_vm.isItemRemoved(
                            _vm.item,
                            _vm.getItemAssessments(_vm.item)
                          )
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.item.itemNo,
                                    expression: "item.itemNo",
                                  },
                                  {
                                    name: "focus-next",
                                    rawName: "v-focus-next:callback",
                                    value: _vm.handleTransitionNextRow,
                                    expression: "handleTransitionNextRow",
                                    arg: "callback",
                                  },
                                ],
                                staticClass: "input",
                                class: [
                                  _vm.defaultRowColourClass(
                                    _vm.item,
                                    _vm.getItemAssessments(_vm.item)
                                  ),
                                  !_vm.isValidItemNo(_vm.item.quoteItemId)
                                    ? "is-danger"
                                    : "",
                                ],
                                attrs: {
                                  placeholder: "Item No.",
                                  disabled: _vm.item.deleteOtherItem,
                                },
                                domProps: { value: _vm.item.itemNo },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.item,
                                      "itemNo",
                                      $event.target.value
                                    )
                                  },
                                },
                              })
                            : _c("span", [_vm._v(_vm._s(_vm.item.itemNo))]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "itemStatus",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                theme: "secondary",
                                enabled: true,
                                content: "Item Status",
                              },
                              expression:
                                "{ theme: 'secondary', enabled: true, content: 'Item Status' }",
                            },
                          ],
                        },
                        [
                          !_vm.readOnlyView &&
                          !_vm.isItemRemoved(
                            _vm.item,
                            _vm.getItemAssessments(_vm.item)
                          )
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.item.itemStatus,
                                    expression: "item.itemStatus",
                                  },
                                  {
                                    name: "focus-next",
                                    rawName: "v-focus-next:callback",
                                    value: _vm.handleTransitionNextRow,
                                    expression: "handleTransitionNextRow",
                                    arg: "callback",
                                  },
                                ],
                                staticClass: "input is-capitalized",
                                domProps: { value: _vm.item.itemStatus },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.item,
                                      "itemStatus",
                                      $event.target.value
                                    )
                                  },
                                },
                              })
                            : _c("span", [_vm._v(_vm._s(_vm.item.itemStatus))]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }